<template>
<div>
  <Snapshot
    :is-snap-shot-sidebar-active.sync="isSnapShotSidebarActive"
    :user-data="userData"
    user-type="MEMBER"
    @clicked="one"
  />

<SidebarCameraPreview
  :is-camera-sidebar-active.sync="isCameraSidebarActive"
/>


  <b-modal
      id="modal-xl"
      ref="modal-debit"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      
      button-size="sm"
      size="md"
      title="Debit Records"
    >
      <app-timeline>
    <app-timeline-item
      v-for="record in debit_records" :key="index" 
      :title=record.action_type
      :subtitle=record.amount
      :time="record.formatted_datetime"
      :variant="record.variant"
    />
  </app-timeline>
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>



    <b-modal
      id="modal-xl"
      ref="modal-remarks"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      
      button-size="sm"
      size="md"
      title="Remarks"
    >
      <app-timeline>
    <app-timeline-item
      v-for="remark in full_remarks" :key="index" 
      :title=remark.display_name
      :subtitle=remark.remarks
      :icon="remark.icon"
      :time="remark.formatted_datetime"
      :variant="remark.type"
    />
  </app-timeline>
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>
    <!-- Header: Personal Info -->
    <b-modal
      id="modal-xl"
      ref="my-modal"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      centered
      button-size="sm"
      size="lg"
      title="Snapshot"
    >
     <embed src="//www.cloudfit.pro/snapshot.php" width="100%" height="600px">
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>


    <b-row>
        <b-col md="7" lg="6">
          <div class="d-flex">
              <feather-icon icon="UserIcon" size="19"/>
              <h4 class="mb-0 ml-50">
                  {{ $t('Personal Information') }}
              </h4>
          </div>
            <!-- Form: Personal Info Form -->
            <b-form class="mt-1">
                <b-row>
                    <!-- Field: Mobile -->
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Member Code')" label-for="member_code">
                            <b-form-input id="member_code" v-model="userData.member_code"/>
                        </b-form-group>
                    </b-col>
                     <b-col cols="12" md="6" lg="4" v-if="$can('read', 'staff')">
                        <b-form-group :label="$t('Date Of Birth')" label-for="birth-date">
                            <flat-pickr v-model="userData.birth" class="form-control" :config="{ dateFormat: 'Y-m-d'}" placeholder="YYYY-MM-DD"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Mobile')" label-for="mobile">
                            <b-form-input id="mobile" v-model="userData.mobile"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Chinese Name')" label-for="zh_name">
                            <b-form-input id="zh_name" v-model="userData.zh_name"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('English Name')" label-for="en_name">
                            <b-form-input id="en_name" v-model="userData.en_name"/>
                        </b-form-group>
                    </b-col>

                   
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('E-Mail')" label-for="email">
                            <b-form-input id="email" v-model="userData.email"/>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="12" md="6" lg="6" v-if="permission_check(client_module.functions,37)">
                        <b-form-group :label="$t('Address')" label-for="address">
                            <b-form-input id="address" v-model="userData.address"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" v-if="permission_check(client_module.functions,37)">
                        <b-form-group :label="$t('Identity Number')" label-for="identity_number">
                            <b-form-input id="identity_number" v-model="userData.identity_card"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Gender')" label-for="gender">
                            <v-select v-model="userData.gender" :options="genderOptions" :clearable="false" input-id="gender"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Created at')" label-for="created_at">
                            <b-form-input id="created_at" v-model="userData.created_at" disabled/>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Status')" label-for="status">
                            <v-select v-model="userData.status" :reduce="ans => ans.value" :options="statusOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>
                    
                   
                    <b-col cols="8" md="6" lg="8">
                        <b-form-group :label="$t('TAGS')" label-for="Tag">
                            <v-select 
                              v-model="userData.tags" 
                              label="label"
                              :options="tagOptions" 
                              :clearable="true" 
                              taggable
                              push-tags
                              multiple 
                              input-id="user_id"/>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2 mb-2">
                    <b-col>
                        <b-button
                            variant="primary"
                            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                            @click="save_member"
                            v-if="permission_check(client_module.functions,55)">
                            Save Changes
                        </b-button>
                        <b-button v-if="permission_check(client_module.functions,55)" variant="outline-secondary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" :to="{ name: 'member-list' }">
                            Cancel
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-col>
        <b-col  md="4" lg="3">

          <img
            style="width:100%;border-radius:10px;"
            ref="previewEl"
            @error="userData.avatar = ''"
            :src="userData.avatar"
            size="100%"
            @click="update_to_device()"
            rounded
            class="mb-1"
          /><br>
          <b-alert
      v-height-fade.appear
      variant="danger"
      :show="userData.spam =='Y'"
      class="mb-0"
    >
      <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50"
        />
        已拒收whatsapp訊息
      </div>
    </b-alert>
          <b-button
            class="mt-1"
            block
            variant="primary"
            @click="snapshot2()"
            v-if="permission_check(client_module.functions,41)"
          >
          <feather-icon icon="CameraIcon" />
           <span> {{ $t('Start Camera') }} </span>
          </b-button>
          <!-- <b-button
            class="mt-1"
            block
            variant="success"
            @click="isCameraSidebarActive = true"
          >
            <feather-icon icon="VideoIcon" />
            <span> Camera Preview </span>
          </b-button> -->

          <!-- <b-button
            class="mt-1"
            block
            variant="outline-primary"
            @click="update_card()"
          >
          <feather-icon icon="RssIcon" />
          <span  v-if="userData.card_id"> {{ $t('Update Card') }} </span>
          <span  v-if="!userData.card_id"> {{ $t('Register Card') }} </span>
          </b-button> -->

          <b-button
            class="my-1"
            block
            size="sm"
            variant="outline-success"
            @click="update_to_device()"
            v-if="permission_check(client_module.functions,41)"
          >
          <feather-icon icon="RefreshCwIcon" />
           <span> {{ $t('Update Access Control') }} # {{ userData.member_id }} </span>
          </b-button>


          <div v-if="client_module.module.includes('debit')">
          <hr>
          <h4 class="mb-2"> <feather-icon icon="CreditCardIcon" size="19" /> {{ $t('Debit') }}</h4>
          <div class="text-center">
            <b-badge
              href="#"
              pill
              class="d-block"
              variant="warning"
              @click="view_debit_records()"
            >
            <feather-icon icon="CreditCardIcon" size="19" /> $ {{ userData.debit }}
            </b-badge>
          </div>
          </div>

        </b-col>
        <b-col lg="3">
          <h4 class="mb-1">特定出入規則 </h4>

          <b-list-group flush v-if="custom_rule_list.length > 0">
            <b-list-group-item v-for="rule in custom_rule_list" :key="index">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <b-badge v-if="rule.action =='allow'" :variant="'success'" style="cursor: pointer;" @click="delete_custom_rule(rule.id)">可進出</b-badge>
                  <b-badge v-if="rule.action =='deny'" :variant="'danger'" style="cursor: pointer;" @click="delete_custom_rule(rule.id)">禁止進出</b-badge>
                  <span class="ml-1">{{ rule.start }} - {{ rule.end }}</span>
                  
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
               <b-button-group size="sm" style="width:100%;">
      <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
       @click="custom_rule.action = 'allow'; action_type = 'success'"
      variant="outline-success"
    >
      <feather-icon :icon="'CheckIcon'" />
    </b-button>

    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-danger"
       @click="custom_rule.action = 'deny'; action_type = 'danger'"
    >
     <feather-icon :icon="'XIcon'" />
    </b-button>
  </b-button-group>
  <br><br>
<b-label class="mt-1">開始時間</b-label>
        <flat-pickr
          v-model="custom_rule.start"
          class="form-control"
          :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i',}"
        />
        <br>
        <b-label class="mt-1">結束時間</b-label>
<flat-pickr
          v-model="custom_rule.end"
          class="form-control"
          :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i',}"
        />    <b-button size="sm" block class="my-1" @click="submit_custom_rule" :variant="action_type">Submit</b-button>


           <hr />
          <h4 class="mb-1">
                  {{ $t('Remarks') }} 
              </h4>
              <b-button-group size="sm" style="width:100%;">
                       <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
       @click="remarks_type = 'primary'"
      variant="outline-primary"
    >
      <feather-icon :icon="'Edit2Icon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-info"
       @click="remarks_type = 'info'"
    >
           <feather-icon :icon="'InfoIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-danger"
       @click="remarks_type = 'danger'"
    >
     <feather-icon :icon="'AlertTriangleIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-warning"
       @click="remarks_type = 'warning'"
    >
           <feather-icon :icon="'BellIcon'" />
    </b-button>

  </b-button-group>
    <b-form-textarea id="remarks" v-model="remarks_input" class="my-1"/>
    <b-button size="sm" block class="mb-1" @click="submit_remarks" :variant="remarks_type">Submit</b-button>
    <hr />
          <app-timeline>

    <app-timeline-item
      v-for="remark in remarks" :key="index" 
      :variant="remark.type"
      :icon="remark.icon"
    >

      <div class="d-flex align-items-start flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-50">
        
        <h6>{{remark.display_name}}</h6>
        <b-badge
          
          variant="light-primary"
        >
          {{remark.formatted_datetime }}
        </b-badge>
      </div>
      <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
       <div>{{ remark.remarks }}</div>
        <div v-if="permission_check(client_module.functions,40)">
          <feather-icon icon="Trash2Icon" style="color:red;cursor: pointer;" @click="delete_remarks(remark.id)"/>
        </div>
      </div>
    </app-timeline-item>
  </app-timeline>
  <b-button @click="view_log()" class="mt-1" block size="sm" variant="outline-secondary">View All</b-button>
</b-col>
    </b-row>
</div>
</template>



<script>
import {
   BFormTextarea, BCardText,BLabel, BButtonGroup,BAlert, BLink, BCard,BMedia, BAvatar, BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,BListGroup, BListGroupItem,BBadge
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import SidebarCameraPreview from './SidebarCameraPreview.vue'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Snapshot from './SidebarSnapshot.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'


export default {
  components: {
    ToastificationContent,
     BFormTextarea,
 'v-easy-camera': EasyCamera,
 AppTimeline,
 AppTimelineItem,
     BBadge,
     BButtonGroup, BButton,
     BCard,
     Snapshot,
     BCardText,
     BLabel,
    vSelect,
    flatPickr,
    BAvatar,
    BListGroup, BListGroupItem,
    BForm,
    BFormGroup,SidebarCameraPreview,
    BMedia,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
    directives: {
    Ripple,
  },
  data() {
    return {
      picture: null,
      custom_rule: {
        action: 'allow',
        start: null,
        end: null,
      },
      remarks:[],
      full_remarks:[],
      capturing : false,
      client_module:JSON.parse(localStorage.getItem('userData')),
      startOnMounted: false,
      centerOptions: [],
      custom_rule_list: [],
      action_type: 'success',
      debit_records: [],
      isSnapShotSidebarActive:false,
      staffOptions: [],
      isCameraSidebarActive: false,
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      tagOptions:[],
      remarks_input: null,
      remarks_type: 'primary',
      statusOptions: [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Disable', value: 'DISABLED' },
        { label: 'Deleted', value: 'DELETED' },
      ],
      actionOptions: [
        { name: 'Allow', value: 'allow' },
        { name: 'Deny', value: 'deny' },
      ],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],

    }
  },
  created() {
    this.get_member_data()
    this.get_center_data()
    this.get_staff_list()
    this.get_tag_data()
    this.get_member_remarks(5)
    this.get_member_custom_rules()
  },
  methods: {
     get_member_remarks(limit) {
      this.$http.get(process.env.VUE_APP_API_BASE+`/member/${router.currentRoute.params.id}/remarks/?limit=`+limit)
        .then(res => {
          this.full_remarks = res.data.remarks
          if (res.data.remarks.length <= 5) {
            this.remarks = res.data.remarks
          }
        })
    },
    get_member_debit(limit) {
      this.$http.get(process.env.VUE_APP_API_BASE+`/member/${router.currentRoute.params.id}/debits/?limit=`+limit)
        .then(res => {
          this.debit_records = res.data.records
          if (res.data.remarks.length <= 5) {
            this.debit_records = res.data.records
          }
        })
    },
    view_log() {
        this.get_member_remarks(50)
      this.$refs['modal-remarks'].show()
    },
    view_debit_records() {
      this.get_member_debit(20)
      this.$refs['modal-debit'].show()
    },
    delete_custom_rule(id) {
      this.$http.post(process.env.VUE_APP_API_BASE+`/member/${this.userData.member_id}/custom_rule/delete/`, {id: id})
          .then(res => {
            if (res.data.result === true) {
              this.custom_rule_list = res.data.rules
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: res.data.message,
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: res.data.message,
                },
              })
            }
          })
    },
    submit_custom_rule() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/member/${this.userData.member_id}/custom_rule/`, this.custom_rule)
          .then(res => {
            if (res.data.result === true) {
this.custom_rule_list = res.data.rules
              
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: res.data.message,
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: res.data.message,
                },
              })
            }
          })
    },
    submit_remarks() {
     this.$http.post(process.env.VUE_APP_API_BASE+`/member/${this.userData.member_id}/remarks/`, {remarks: this.remarks_input,type:this.remarks_type})
        .then(res => {
          if (res.data.result === true) {
            this.remarks_input = null
            this.remarks_type = 'primary'
            this.get_member_remarks(5)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
     delete_remarks(id) {
     this.$http.post(process.env.VUE_APP_API_BASE+`/member/${this.userData.member_id}/remarks/delete/`, {id: id})
        .then(res => {
          if (res.data.result === true) {
            this.get_member_remarks(5)
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    one() {
      this.isSnapShotSidebarActive = false
      this.get_member_data()
    },
    update_card() {
         localStorage.setItem('reader_action', 'update_member_card')
         localStorage.setItem('member_id', this.userData.member_id)
         this.$swal({
          title: 'Please Scan NFC Card',
          icon: 'info',
          allowOutsideClick: false,
          confirmButtonText: this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            localStorage.setItem('reader_action', 'normal')
            localStorage.removeItem('member_id')
          }
        })
    },
    update_card_v2() {
         localStorage.setItem('reader_action', 'update_member_card')
         localStorage.setItem('member_id', this.userData.member_id)
         this.$swal({
          title: 'Please Scan NFC Card',
          icon: 'info',
          allowOutsideClick: false,
          confirmButtonText: this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            localStorage.setItem('reader_action', 'normal')
            localStorage.removeItem('member_id')
          }
        })
    },
    go() {
        window.location = 'https://www.cloudfit.pro/snapshot.php?token='+this.userData.token
    },
    snapshot2() {
      this.isSnapShotSidebarActive = true
    },
    start_cam() {
      this.capturing = true
      this.$refs.cam.start()
      this.$refs.cam.start()
    },
        close() {
      this.full_remarks = []
      this.$refs['modal-remarks'].hide()
      this.$refs['modal-debit'].hide()
    },
    capture() {
      this.$refs.cam.snap()
    },
    old_capture() {
      this.$refs['my-modal'].show()
    },
    void_deposit(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, void deposit!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed === true) {
        this.$http.post(process.env.VUE_APP_API_BASE+`/transaction/`+id+`/delete/`, {})
          .then(res => {
              this.get_member_data()
              this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Deposit voided',
              },
            })
          })
        } else {
          this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Cancelled',
                icon: 'AlertCircleIcon',
                variant: 'warning',
                text: 'Action Cancelled'
              },
            })
        }
      })
    },
    get_staff_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/?mode=all')
        .then(res => {
          this.staffOptions = res.data
        })
    },
       get_member_custom_rules() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/member/${router.currentRoute.params.id}/custom_rule/`)
        .then(res => {
          this.custom_rule_list = res.data.rules
        })
    },
    update_to_device() {
      this.$http.post(`https://www.cloudfit.pro/access_control/api/v1/upload/${router.currentRoute.params.id}`)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    save_member() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/member/${this.userData.member_id}/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    snapshot() {
      this.$refs['my-modal'].show()
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_tag_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/tags/select/')
        .then(res => {
          this.tagOptions = res.data.tags
        })
    },
    get_member_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/member/${router.currentRoute.params.id}/`)
        .then(res => {
          this.userData = res.data
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
